import {WEBP_URL_SUFFIX} from './imageConstants';

function isRetina() {
  if (process.env.BROWSER && window) {
    return window.devicePixelRatio >= 2;
  }
  return false;
}

function isAvailableRetinaImage(image, options, factor = 2) {
  return image.width >= options.width * factor ||
    image.height >= options.height * factor;
}

function getEarlyHintsImagesForMobilePLP({products, banner, cardType}) {
  if (banner?.preloadBannerImage?.image1x) {
    return `<${banner?.preloadBannerImage?.image1x}>; as=image; rel=preload`
  }

  if (products) {
    const firstFourProducts = cardType === null ? products?.slice(0, 2) : products?.slice(0, 4)
    //const size = cardType === 'Cozy' ? '300-400' : cardType === 'Comfort' ? '300-300' : '300-443'
    const size = '300-443'
    if (firstFourProducts?.length) {
      return firstFourProducts.map((product) => {
        const image = product?.images?.[0]

        return `<${image?.linkFormat?.replace('{size}', size)}${WEBP_URL_SUFFIX}>; as=image; rel=preload`
      }).join(',')
    }
  }

  return null
}

function getImageSize(image, options, useRetinaImageSize, factor = 2) {
  if (useRetinaImageSize && isAvailableRetinaImage(image, options)) {
    return {
      width: options.width * factor,
      height: options.height * factor,
    }
  }
  return {
    width: options.width,
    height: options.height,
  }
}

/**
 *
 * @param image {object}
 * @returns {string|*}
 */
function generateImageSrc(image) {
  let isOriginalImage = false;
  const {
    src: imageSrc,
    size: imageSize,
  } = image;

  if (!imageSrc) {
    return null;
  }

  let processedImageSrc = imageSrc;
  if (imageSrc.indexOf('productimages') > -1) {
    if (imageSrc.indexOf('#imgSize') > -1) {
      processedImageSrc = imageSrc.replace('#imgSize', imageSize);
    } else if (imageSrc.indexOf('{size}') > -1) {
      processedImageSrc = imageSrc.replace('{size}', imageSize);
    }
  } else if (imageSrc.indexOf('dali-banner') > -1) {
    if (imageSrc.indexOf('#imgSize') > -1) {
      processedImageSrc = imageSrc.replace('#imgSize', imageSize);
    } else if (imageSrc.indexOf('{size}') > -1) {
      processedImageSrc = imageSrc.replace('{size}', imageSize);
    }
  } else if (imageSrc.indexOf('images') > -1) {
    if (imageSrc.indexOf('#imgSize') > -1) {
      processedImageSrc = imageSrc.replace('#imgSize', imageSize);
    } else if (imageSrc.indexOf('{size}') > -1) {
      processedImageSrc = imageSrc.replace('{size}', imageSize);
    } else {
      isOriginalImage = true;
      processedImageSrc = imageSrc;
    }
  } else {
    isOriginalImage = true;
    processedImageSrc = imageSrc;
  }

  return {
    isOriginalImage: isOriginalImage,
    src: processedImageSrc,
  };
}

/**
 * @param image {object}
 * @param imageSize (string - 200-200)
 * @param src (string)
 * @returns {{png2x: *, png: *}|boolean}
 */
function generateImageSrcSet(image, imageSize, src) {
  if (image && imageSize) {
    const width = imageSize.split('-')[0];
    const height = imageSize.split('-')[1];
    let setRetina2xImageUrl;
    let setRetina3xImageUrl;

    const retinaImage2xSize = typeof height == 'undefined' ? `${width * 2}` : `${width * 2}-${height * 2}`;
    const retinaImage3xSize = typeof height == 'undefined' ? `${width * 3}` : `${width * 3}-${height * 3}`;
    if (src.indexOf('productimages') > -1) {
      if (src.indexOf('#imgSize') > -1) {
        setRetina2xImageUrl = src.replace('#imgSize', retinaImage2xSize);
        setRetina3xImageUrl = src.replace('#imgSize', retinaImage3xSize);
      } else if (src.indexOf('{size}') > -1) {
        setRetina2xImageUrl = src.replace('{size}', retinaImage2xSize);
        setRetina3xImageUrl = src.replace('{size}', retinaImage3xSize);
      }
    } else if (src.indexOf('dali-banner') > -1) {
      if (src.indexOf('#imgSize') > -1) {
        setRetina2xImageUrl = src.replace('#imgSize', retinaImage2xSize);
        setRetina3xImageUrl = src.replace('#imgSize', retinaImage3xSize);
      } else if (src.indexOf('{size}') > -1) {
        setRetina2xImageUrl = src.replace('{size}', retinaImage2xSize);
        setRetina3xImageUrl = src.replace('{size}', retinaImage3xSize);
      }
    } else if (src.indexOf('images') > -1) {
      if (src.indexOf('#imgSize') > -1) {
        setRetina2xImageUrl = src.replace('#imgSize', retinaImage2xSize);
        setRetina3xImageUrl = src.replace('#imgSize', retinaImage3xSize);
      } else if (src.indexOf('{size}') > -1) {
        setRetina2xImageUrl = src.replace('{size}', retinaImage2xSize);
        setRetina3xImageUrl = src.replace('{size}', retinaImage3xSize);
      }
    } else {
      return {
        png: image,
      }
    }
    return {
      png: image,
      png2x: setRetina2xImageUrl,
      png3x: setRetina3xImageUrl,
    }
  }
  return false;
}

/**
 *
 * @param image(object||string)
 * @returns {{webp: string, webp2x: string}}
 */
function generateImageWebp(image) {
  if (typeof image === 'object') {
    return {
      webp: image.png + WEBP_URL_SUFFIX,
      webp2x: image.png2x + WEBP_URL_SUFFIX,
      webp3x: image.png3x + WEBP_URL_SUFFIX,
    }
  }

  return {
    webp: image + WEBP_URL_SUFFIX,
  }
}

export {
  generateImageSrcSet,
  isRetina,
  generateImageWebp,
  generateImageSrc,
  getImageSize,
  isAvailableRetinaImage,
  getEarlyHintsImagesForMobilePLP,
}
